import { useTranslation } from 'react-i18next';
import { Card, CardHeader, CardContent } from "src/@/components/ui/card";
import { LabelFromAction } from "src/components/@dashboard/automacoes";
import { MultiSelect } from "src/@/components/ui/multi-select";
import { RowInput } from "src/components/forms/RowInput";
import AutomationOnlyExecute from "../components/AutomationOnlyExecute";

const CardTarefaGeneric = ({
    actionPhase,
    actionState,
    changeActionState,
    users
}) => {
    const { t } = useTranslation('automation');
    return (
        <Card className="w-full">
            <CardHeader>
                <LabelFromAction>
                    {actionPhase.name}
                </LabelFromAction>
            </CardHeader>
            <CardContent>
                <div className="flex flex-col gap-4">
                    <RowInput
                        label={t('actionCard.tarefa.assignedUserLabel', 'Usuário atribuído')}
                        info={t('actionCard.tarefa.assignedUserInfo', 'Filtrar por usuário atribuído na tarefa')}
                        input={
                            <MultiSelect
                                options={users}
                                onValueChange={(e) =>
                                    changeActionState({ name: "tarefaUsersAssign", value: e })
                                }
                                defaultValue={actionState?.tarefaUsersAssign}
                                placeholder={t('actionCard.shared.usersOptionalPlaceholder', 'Selecionar usuários (opcional)')}
                                variant="inverted"
                                animation={2}
                                maxCount={3}
                            />
                        }
                    />
                    <AutomationOnlyExecute
                        actionState={actionState}
                        changeActionState={changeActionState}
                    />
                </div>
            </CardContent>
        </Card>
    );
};

export default CardTarefaGeneric;
